import {defineStore} from 'pinia'
import {ref, reactive, computed, nextTick} from "vue"
import router from "@/router";
import {ROUTE_NAMES} from "@/router"
import Supabase from "@/utils/Supabase";

const useContentStore = defineStore('contentStore', () => {

    const appCategories = ref([])
    const appCategoriesList = computed(() => ({
        BO: appCategories.value.filter(c => c.restaurantPlace === 'BO'),
        PE: appCategories.value.filter(c => c.restaurantPlace === 'PE'),
    }))
    const loadingCategories = ref(false)
    const loadCategories = async () => {
        loadingCategories.value = true
        const {
            data,
            error
        } = await Supabase.from('v2_Hajcer_App_Categories').select('*').order('order', {ascending: true})
        loadingCategories.value = false
        if (error) {
            alert('Error loading categories')
            return
        }
        appCategories.value = data
    }

    const appProducts = ref([])
    const appProductsList = computed(() => ({
        BO: appProducts.value.filter(c => c.restaurantPlace === 'BO'),
        PE: appProducts.value.filter(c => c.restaurantPlace === 'PE'),
    }))
    const loadingProducts = ref(false)
    const loadProducts = async () => {
        loadingProducts.value = true
        const {data, error} = await Supabase.from('v2_Hajcer_App_Products').select(` *, pluItem:pluItemId (*)`)
        loadingProducts.value = false

        if (error) {
            alert('Error loading app products ')
            return
        }
        appProducts.value = data
    }

    const mealsExtras = ref([])
    const loadingMealsExtras = ref(false)
    const mealsExtrasList = computed(() => ({
        BO: mealsExtras.value.filter(c => c.restaurantPlace === 'BO'),
        PE: mealsExtras.value.filter(c => c.restaurantPlace === 'PE'),
    }))
    const loadMealExtras = async () => {
        loadingMealsExtras.value = true
        const {
            data,
            error
        } = await Supabase.from('v2_Hajcer_App_Products_Extra').select(`*, items:v2_Hajcer_App_Products_Extra_Products (*)`).order('createdAt', {ascending: true})
        loadingMealsExtras.value = false
        mealsExtras.value = data
    }

    const loadingFlyParts = ref(false)
    const flyParts = ref([])
    const loadFlyParts = async () => {
        loadingFlyParts.value = true
        const {data, error} = await Supabase.from('v2_Hajcer_App_Products_Fly_Parts').select().order('order', {ascending: false})
        if (error) {
            alert('Error')
            console.error(error)
        } else {
            flyParts.value = data
        }
        loadingFlyParts.value = false

    }

    return {
        // categories
        appCategories,
        loadCategories,
        loadingCategories,
        appCategoriesList,
        // products
        appProducts,
        loadProducts,
        loadingProducts,
        appProductsList,
        // meals extras
        mealsExtras,
        loadMealExtras,
        loadingMealsExtras,
        mealsExtrasList,
        // fly parts
        flyParts,
        loadFlyParts
    }


})

export default useContentStore